import React, { useState, useEffect } from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import Sidebar from "../../../partials/aside/Sidebar";
import TitleBar from "../../../partials/content/TitleBar";
import httpService from "../../../../services/httpServices/httpServices";
import helperNumber from "../../../../helpers/numbers";
import helperSpinner from "../../../../helpers/spinner";
import helperTime from "../../../../helpers/time";
import PageConstants from "./PageConstants";
import TypePageConstant from "../TypePageConstant";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export default function ViewPageSitePublisher() {
  const [pageSitePublisher, setPageSitePublisher] = useState();
  const params = useParams();
  const pageID = parseInt(params.pageID);
  const history = useHistory();
  useEffect(() => {
    getPageSitePublisher();
  }, []);

  const setStatePageSitePublisher = async () => {
    const formDate = {
      message: document.querySelector("#message").value,
      state: document.querySelector("#state").value,
    };

    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let page = await sendRequestSetStatePageSitePublisher(pageID, formDate);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!page) {
      return;
    }

    history.push(
      `/page/manage/all/publisher/${pageSitePublisher.pap_web_site_publisher_id} `
    );
  };

  const sendRequestSetStatePageSitePublisher = async (pageID, formDate) => {
    const headersRequest = getHeaderRequest();
    let pageSitePublisher;
    try {
      pageSitePublisher = await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API +
          `/v1/manage/publisher/page/${pageID}`,
        formDate,
        headersRequest
      );
    } catch (error) {
      return false;
    }

    return true;
  };

  const getPageSitePublisher = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let page = await sendRequestGetPageSitePublisher(pageID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!page) {
      return;
    }
    setPageSitePublisher(page);
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestGetPageSitePublisher = async (pageID) => {
    const headersRequest = getHeaderRequest();
    let pageSitePublisher;
    try {
      pageSitePublisher = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          `/v1/manage/publisher/page/${pageID}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return pageSitePublisher.data.data;
  };

  const checkPageStateIsPendingEditOrRejectEdit = () => {
    if (
      pageSitePublisher.pap_state ==
        PageConstants.statusSiteUserPublisher.PENDING_EDIT ||
      pageSitePublisher.pap_state ==
        PageConstants.statusSiteUserPublisher.REJECT_EDIT
    ) {
      return true;
    }
    return false;
  };

  const generatePageTemporarySitePublisherInfo = () => {
    if (!checkPageStateIsPendingEditOrRejectEdit()) {
      return <></>;
    }
    const pageTemporary = pageSitePublisher.page_temporary;

    return (
      <div className="pt-2">
        <div className="alert alert-warning">اطلاعات صفحه ویرایش شده</div>
        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td
                  colSpan={2}
                  className="text-center"
                  style={{ borderRadius: "25px 25px 0 0" }}
                >
                  <b>اطلاعات صفحه</b>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>شماره صفحه</td>
                <td>{pageTemporary.ppt_id}</td>
              </tr>
              <tr>
                <td>عنوان </td>
                <td>
                  {pageTemporary.ppt_title}
                  {pageTemporary.ppt_pattern_url.includes("/@s") ? (
                    <span className="pr-2">
                      <span className="badge badge-success">
                        {
                          TypePageConstant.typePageString()[
                            TypePageConstant.typePage.MULTI_PAGE
                          ]
                        }
                      </span>
                    </span>
                  ) : (
                    <span className="pr-2">
                      <span className="badge badge-warning">
                        {
                          TypePageConstant.typePageString()[
                            TypePageConstant.typePage.STATIC
                          ]
                        }
                      </span>
                    </span>
                  )}
                </td>
              </tr>
              <tr>
                <td>الگوی آدرس </td>
                <td className="text-left ltr">
                  {pageTemporary.ppt_pattern_url}
                </td>
              </tr>
              <tr>
                <td>لینک</td>
                <td className="text-left ltr">
                  <span className="pr-2">{pageTemporary.ppt_link}</span>
                  <span>
                    <a
                      href={pageTemporary.ppt_link}
                      target="_blank"
                      className="btn btn-info"
                    >
                      <i className="fa fa-link"></i>
                    </a>
                  </span>
                </td>
              </tr>
              <tr>
                <td>وضعیت</td>
                <td>
                  <div dir="ltr">
                    {pageTemporary.ppt_active ? (
                      <span className="badge badge-success">فعال</span>
                    ) : (
                      <span className="badge badge-danger">غیرفعال</span>
                    )}
                  </div>
                </td>
              </tr>
              <tr>
                <td>تاریخ درج </td>
                <td>
                  {helperNumber.toPersianNum(
                    pageTemporary.ppt_created_at.split(" ")[1] +
                      " " +
                      helperTime.convertGregorianToJalali(
                        pageTemporary.ppt_created_at.split(" ")[0]
                      )
                  )}
                </td>
              </tr>
              <tr>
                <td>عکس صفحه</td>
                <td>
                  <a
                    target="_blank"
                    href={`${process.env.REACT_APP_DOMAIN_API}/${process.env.REACT_APP_URL_PAGE_FILES}/${pageTemporary.ppt_img_name}`}
                  >
                    <img
                      className="border border-success img-fluid"
                      src={`${process.env.REACT_APP_DOMAIN_API}/${process.env.REACT_APP_URL_PAGE_FILES}/${pageTemporary.ppt_img_name}`}
                    />
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  const generatePageSitePublisherInfo = () => {
    let classBadgeStatePage;
    switch (pageSitePublisher.pap_state) {
      case PageConstants.statusSiteUserPublisher.PENDING:
        classBadgeStatePage = "badge-warning";
        break;
      case PageConstants.statusSiteUserPublisher.CONFIRM:
        classBadgeStatePage = "badge-info";
        break;
      case PageConstants.statusSiteUserPublisher.REJECT:
        classBadgeStatePage = "badge-danger";
        break;
      case PageConstants.statusSiteUserPublisher.REJECT_EDIT:
        classBadgeStatePage = "badge-danger";
        break;
      case PageConstants.statusSiteUserPublisher.PENDING_EDIT:
        classBadgeStatePage = "badge-warning";
        break;
    }

    return (
      <>
        {pageSitePublisher.pap_state ==
          PageConstants.statusSiteUserPublisher.PENDING_EDIT && (
          <div className="alert alert-warning">
            <p className="text-justify">
              <i className="fa fa-info pl-2"></i>
              توجه داشته باشید :{" "}
            </p>
            <ul className="pr-3">
              <li>
                <p>
                  صفحه کاربر قبلا در حالت تایید شده بوده و کاربر آنرا ویرایش
                  کرده.اطلاعات جدید صفحه که کاربر وارد کرده است را در انتهای
                  صفحه نمایش داده شده است و به آنها توجه کنید.
                </p>
              </li>
            </ul>
          </div>
        )}

        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td
                  colSpan={2}
                  className="text-center"
                  style={{ borderRadius: "25px 25px 0 0" }}
                >
                  <b>اطلاعات صفحه</b>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>عنوان </td>
                <td>
                  {pageSitePublisher.pap_title}
                  {pageSitePublisher.pap_pattern_url.includes("/@s") ? (
                    <span className="pr-2">
                      <span className="badge badge-success">
                        {
                          TypePageConstant.typePageString()[
                            TypePageConstant.typePage.MULTI_PAGE
                          ]
                        }
                      </span>
                    </span>
                  ) : (
                    <span className="pr-2">
                      <span className="badge badge-warning">
                        {
                          TypePageConstant.typePageString()[
                            TypePageConstant.typePage.STATIC
                          ]
                        }
                      </span>
                    </span>
                  )}
                </td>
              </tr>
              <tr>
                <td>الگوی آدرس </td>
                <td className="text-left ltr">
                  {pageSitePublisher.pap_pattern_url}
                </td>
              </tr>
              <tr>
                <td>لینک</td>
                <td className="text-left ltr">
                  <span className="pr-2">
                    {decodeURI(pageSitePublisher.pap_link)}
                  </span>
                  <span>
                    <a
                      href={pageSitePublisher.pap_link}
                      target="_blank"
                      className="btn btn-info"
                    >
                      <i className="fa fa-link"></i>
                    </a>
                  </span>
                </td>
              </tr>
              <tr>
                <td>حالت</td>
                <td>
                  <span className={`badge ${classBadgeStatePage}`}>
                    {
                      PageConstants.getStatusSiteUserPublisherString()[
                        pageSitePublisher.pap_state
                      ]
                    }
                  </span>
                </td>
              </tr>
              <tr>
                <td>وضعیت</td>
                <td>
                  <div dir="ltr">
                    {pageSitePublisher.pap_active ? (
                      <span className="badge badge-success">فعال</span>
                    ) : (
                      <span className="badge badge-danger">غیرفعال</span>
                    )}
                  </div>
                </td>
              </tr>

              <tr>
                <td>آخرین پیغام ارسال شده به کاربر</td>
                <td>{pageSitePublisher.pap_message}</td>
              </tr>
              <tr>
                <td>تاریخ درج </td>
                <td>
                  {helperNumber.toPersianNum(
                    pageSitePublisher.pap_created_at.split(" ")[1] +
                      " " +
                      helperTime.convertGregorianToJalali(
                        pageSitePublisher.pap_created_at.split(" ")[0]
                      )
                  )}
                </td>
              </tr>
              <tr>
                <td>تاریخ آخرین بروزرسانی </td>
                <td>
                  {helperNumber.toPersianNum(
                    pageSitePublisher.pap_updated_at.split(" ")[1] +
                      " " +
                      helperTime.convertGregorianToJalali(
                        pageSitePublisher.pap_updated_at.split(" ")[0]
                      )
                  )}
                </td>
              </tr>
              <tr>
                <td>عکس صفحه</td>
                <td>
                  <a
                    target="_blank"
                    href={`${process.env.REACT_APP_DOMAIN_API}/${process.env.REACT_APP_URL_PAGE_FILES}/${pageSitePublisher.pap_img_name}`}
                  >
                    <img
                      className="border border-success img-fluid"
                      src={`${process.env.REACT_APP_DOMAIN_API}/${process.env.REACT_APP_URL_PAGE_FILES}/${pageSitePublisher.pap_img_name}`}
                    />
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <hr />
        <div className="pt-2">
          <form
            className="p-2 border border-1"
            onSubmit={(e) => {
              e.preventDefault();
              setStatePageSitePublisher();
            }}
          >
            <div className="alert alert-warning">
              <p className="text-justify">
                <i className="fa fa-info pl-2"></i>
                توجه داشته باشید :{" "}
              </p>
              <ul className="pr-3">
                <li>
                  <p>
                    وضیعت (تایید شده - آخرین ویرایش رد شده) برای وضیعتی است که
                    صفحه در وضیعت تایید شده قرار داشت و نمایش دهنده آن را ویرایش
                    میکند اگر اطلاعات جدید صفحه که نمایش دهنده وارد کرده است ,
                    اطلاعات درستی نباشد وضیعت صفحه به (تایید شده - آخرین ویرایش
                    رد شده) تغییر میکند
                  </p>
                </li>
                <li>
                  <p>
                    در صورت انتخاب وضعیت 'رد شده' و 'تایید شده - آخرین ویرایش رد
                    شده' حتما دلیل خود را برای کاربر نمایش دهنده بنویسید.
                  </p>
                </li>
              </ul>
            </div>
            <h1 className="text-dark"> تغییر وضعیت صفحه </h1>
            <div className="py-2">
              <span>وضعیت : </span>
              <span className="d-inline-block">
                <select className="form-control" id="state">
                  <option value={PageConstants.statusSiteUserPublisher.CONFIRM}>
                    {
                      PageConstants.getStatusSiteUserPublisherString()[
                        PageConstants.statusSiteUserPublisher.CONFIRM
                      ]
                    }
                  </option>
                  <option value={PageConstants.statusSiteUserPublisher.REJECT}>
                    {
                      PageConstants.getStatusSiteUserPublisherString()[
                        PageConstants.statusSiteUserPublisher.REJECT
                      ]
                    }
                  </option>
                  <option
                    value={PageConstants.statusSiteUserPublisher.REJECT_EDIT}
                  >
                    {
                      PageConstants.getStatusSiteUserPublisherString()[
                        PageConstants.statusSiteUserPublisher.REJECT_EDIT
                      ]
                    }
                  </option>
                </select>
              </span>
            </div>
            <div className="py-2">
              <div className="py-2">دلیل رد شدن</div>
              <textarea
                className="form-control"
                id="message"
                rows="4"
              ></textarea>
            </div>
            <div>
              <button className="btn btn-success">اعمال</button>
            </div>
          </form>
        </div>
        <>
          {pageSitePublisher["page_temporary"] &&
            generatePageTemporarySitePublisherInfo()}
        </>
      </>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="صفحات سایت" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="text-left pb-2">
                <Link
                  className="btn btn-primary"
                  to={`/page/manage/all/publisher/${pageSitePublisher?.pap_web_site_publisher_id}`}
                >
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i className="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>

              {pageSitePublisher && generatePageSitePublisherInfo()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
